// Define the interface for the properties
interface DetailProps {
  id: string;
  version: string;
  termsVersion: string;
  description: string;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;
}

// Define default values
const defaultDetailProps: DetailProps = {
  id: '',
  version: '',
  termsVersion: '',
  description: '',
  createdDate: new Date(),
  modifiedDate: new Date(),
  createdBy: '',
  modifiedBy: '',
};

// Create the class implementing the interface
export class DetailModel implements DetailProps {
  id: string;
  version: string;
  termsVersion: string;
  description: string;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;

  constructor(props: Partial<DetailProps> = {}) {
    // Initialize properties with default values and override with provided values
    this.id = props.id ?? defaultDetailProps.id;
    this.version = props.version ?? defaultDetailProps.version;
    this.termsVersion = props.termsVersion ?? defaultDetailProps.termsVersion;
    this.description = props.description ?? defaultDetailProps.description;
    this.createdDate = props.createdDate ?? defaultDetailProps.createdDate;
    this.modifiedDate = props.modifiedDate ?? defaultDetailProps.modifiedDate;
    this.createdBy = props.createdBy ?? defaultDetailProps.createdBy;
    this.modifiedBy = props.modifiedBy ?? defaultDetailProps.modifiedBy;
  }
}
